<template>
  <div class="company-ticket-list">
    <div class="ticket-list-head"></div>
    <div class="ticket-list-body">
      <div class="ticket-list-body-h">
        <h3>工单列表</h3>
        <router-link :to="{name: 'createTicket'}">
          <bcc-button size='large' type="primary">创建工单</bcc-button>
        </router-link>
      </div>
      <div class="ticket-list-body-b">
        <bcc-table
          :columns="ticketColumn"
          :data="ticketData"
          emptyText="当前没有工单"
          :show-loading="ticketDataLoading"
          align="center">
          <template slot="des" slot-scope="scope">
            <span :title="scope.row.des" class="ellipsis-1">{{scope.row.des}}</span>
          </template>
          <template slot="reply" slot-scope="scope">
            <span v-if='scope.row.reply' :title="scope.row.reply" class="ellipsis-1">{{scope.row.reply}}</span>
            <img v-if='scope.row.img_url' @click="handleImage(scope.row.img_url)" class="reply-img" :src="scope.row.img_url" alt="">
          </template>
          <template slot="state" slot-scope="scope">
            <span v-html="renderState(scope.row.state)"></span>
          </template>
          <template slot="ctime" slot-scope="scope">
            <span>{{renderTime(scope.row.ctime)}}</span>
          </template>
          <template slot="etime" slot-scope="scope">
            <span>{{renderTime(scope.row.etime) || '-'}}</span>
          </template>
          <template slot="operate" slot-scope="scope">
            <router-link class="goto-ticket-detail"
                         :to="{name: 'ticketDetail', params: {ticket_id: scope.row.id, name: scope.row.name }, query:{state: scope.row.state}}"
                         @click.native="$LogReport.sendCustomEvent('openplat_ticketmanage_checkticket_click')"
            >查看
            </router-link>
          </template>
        </bcc-table>

        <div class="ticket-list-pagination" v-if='ticketData.length'>
          <p class="txt">每页显示</p>
          <bcc-select v-model="ticketPs" width="80px" class="ps-select" @on-change="changePageSize">
            <bcc-option :value="option.value" v-for="(option, idx) in pageOptions" :key="idx"
                        :label="option.label"/>
          </bcc-select>
          <bcc-pagination
            :current="ticketPn"
            :page-size="ticketPs"
            :total="ticketTotal"
            @on-change="changeticketPage"
            show-elevator
            show-total
          ></bcc-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {login} from "@/utils/login"

export default {
  name: "ticket",
  data() {
    return {
      pageOptions: [{
        label: 10,
        value: 10
      }],
      ticketColumn: [
        {
          title: '工单问题',
          key: 'des'
        },
        {
          title: '工单答复',
          key: 'reply'
        },
        {
          title: '创建时间',
          key: 'ctime',
          style: {
            width: '150px'
          }
        },
        {
          title: '最新回复时间',
          key: 'etime',
          style: {
            width: '150px'
          }
        },
        {
          title: '状态',
          key: 'state',
          style: {
            width: '120px'
          }
        },
        {
          title: '操作',
          key: 'operate',
          style: {
            width: '120px'
          }
        }
      ],
      ticketData: [],
      ticketDataLoading: false,
      ticketPn: 1,
      ticketPs: 10,
      ticketTotal: 0,
      topStatus: null
    }
  },
  created() {
    if (this.$store.state.userInfo) {
      this.$LogReport.sendCustomEvent('openplat_workform_page_load')
      this.renderticketList()
    } else {
      this.$router.push({
        name: 'home'
      })
      login()
    }
  },
  methods: {
    handleImage (img) {
      window.open(img)
    },
    changePageSize() {
      this.renderticketList()
    },
    async renderticketList() {
      this.ticketDataLoading = true
      await this.$api.ticket.viewList({
        mid: this.$store.state.userInfo.mid,
        pn: this.ticketPn,
        ps: this.ticketPs
      }).then(data => {
        let tableData = []
          data.data.forEach((item) => tableData.push({
            ...item.session,
            des: (() => {
              try {
                return JSON.parse(item.session.content).des
              }catch (e){
                return item.session.content
              }
            })(),
            reply: item.last_reply ? item.last_reply.content : '',
            img_url: item.last_reply ? item.last_reply.img_url : '',
            etime: item.last_reply ? item.last_reply.ctime : '',
            name: item.tag.name
          }))
        this.ticketData = tableData
        this.ticketTotal = data.total
        this.ticketDataLoading = false
      }).catch(e => {
        console.error(e)
        if (this.$store.state.companyInfo && this.$store.state.companyInfo === 1) {
          this.$message({
            content: e.message,
            type: 'exception',
            offset: 60,
            duration: 1500
          })
        }
        this.ticketDataLoading = false
      })
    },
    changeticketPage(pn) {
      if (pn <= 0) return
      this.ticketPn = pn
      this.renderticketList()
    },
    renderState(state) {
      switch (state) {
        case 0:
          return '<span style="color: #FAAB4B;">待处理</span>'
        case 1:
          return '<span style="color: #FAAB4B;">处理中</span>'
        case 2:
          return '<span style="color: #8BE09C">处理中</span>'
        case 3:
          return '<span style="color: gray;">已完结</span>'
        case 5:
          return '<span style="color: gray;">已完结</span>'
        case 100:
          return '<span style="color: gray;">已删除</span>'
        default:
          return '<span style="color: #FA5A57;">未知状态(-1)</span>'
      }
    },
    renderTime(time) {
      if(time === '') return ''
      return window.moment.unix(time).format('YYYY-MM-DD HH:mm')
    },
  }
}
</script>

<style scoped lang="scss">
.company-ticket-list {
  min-width: 960px;
  width: 100%;
  max-width: 1168px;
  margin: auto;
}

.ticket-list-head {
  padding: 16px 0 16px 26px;
}

.ticket-list-body {
  border: 1px solid #E7E7E7;
  min-height: 100px;

  .ticket-list-body-h {
    display: flex;
    align-items: center;
    padding: 0 26px;
    border-bottom: 1px solid #E7E7E7;
    height: 64px;
    justify-content: space-between;

    h3 {
      font-size: 24px;
      color: #212121;
    }
  }

  .ticket-list-body-b {
    padding: 24px;

    .ticket-list-pagination {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;

      .txt {
        font-size: 14px;
        margin-right: 20px;
      }

      .ps-select {
        margin-right: 40px;
      }
    }
  }
}

.goto-ticket-detail {
  color: #1389BF;
}

.goto-ticket-detail-disabled {
  cursor: not-allowed !important;
  user-select: none;
  opacity: .5;
}

.reply-img {
  width: 25px;
  height: 25px;
  cursor: pointer;
}
</style>
